import evenbus from '@/utils/eventBus.js'
import store from '../../store/index';
import router from '../../router';
import Vue from 'vue'

import { baseWs } from '@/config';

// 这个是拿来存储 发来的socket
function webscokets(type, wsAdrees) {
  let _this = this
  this.ws = null;
  this.version = '1.0.0'
  this.type = type
  this.wsAdrees = wsAdrees
  this.msgcachelist = []
  this.Init = function () {
    // _this.type == 'all' 是全局公用踢下线的socket并且直播在多平台；'other' 是单平台直播间和聊天室；
    // 所有单平台要连两个，多平台只连一个。
    const imei = window.localStorage.getItem('fingerprintVal')
    const supportsWebSocket = 'WebSocket' in window || 'MozWebSocket' in window
    const showError = (msg) => Vue.prototype.$message.error({
      message: msg,
      type: "error",
      offset: 210,
      duration: 1500,
    })
    const forceLogout = () => {
      store.commit("setToken", ""); //保存token
      store.commit("setUserIfno", {});
      router.push('/login')
    }
    const host = _this.type === 'all' ? baseWs : this.wsAdrees

    if (_this.type === 'all' || (_this.type === 'other' && this.wsAdrees)) {
      if (supportsWebSocket) {
        _this.ws = new ReconnectingWebSocket(
          `${host}?device=web&version=${this.version}&imei=${imei}&platform=public&ws-v=2`
        )
      } else {
        alert('您的浏览器不支持 WebSocket!')
        return
      }
    }
    if (_this.ws) {
      _this.ws.onclose = function () {
        evenbus.$emit('socketFail', _this.type)
      }
      _this.ws.onmessage = (e) => {
        let shuzue = JSON.parse(e.data)
        for (let i = 0; i < shuzue.length; i++) {
          let msg = JSON.parse(shuzue[i])
          // let msg = JSON.parse(e.data)
          if (msg.error && msg.error.code == 100007) {
            showError(msg.error.message)
            return
          }
          if (msg && msg.error && msg.error.code == 100008) {
            showError(msg.error.message)
            return
          }
          // 也是下线的一种状态
          if (msg && msg.error && msg.error.code == 100005) {
            showError(msg.error.message)
            forceLogout()
          }
          if (msg.method) {
            if (msg.method == "conn.message") {
              // 登录失效了
              if (msg.result.code == 100005) {
                showError(msg.result.message)
                forceLogout()
              }
            }
          }
          evenbus.$emit('getAllMsg', JSON.stringify(msg));
        }
        this.heartCheckall.start();
      }
      _this.ws.onopen = function () {
        while (_this.msgcachelist.length) {
          _this.ws.send(_this.msgcachelist.pop())
        }
        _this.heartCheckall.start();
        // 连上过后通知
        evenbus.$emit('socketSuccess', _this.type)
      }
      _this.ws.onerror = function (e) {
      }
    }
  },
    this.Send = function (data) {
      if (_this.ws && _this.ws.readyState == ReconnectingWebSocket.OPEN) {
        let msg = data
        _this.ws.send(JSON.stringify(msg))
      } else {
        // 这种情况没有连上加入队列，等待连上了再处理
        // 这种情况就是连上了
        let msg = data
        _this.msgcachelist.push(JSON.stringify(msg))
      }
    },
    this.heartCheckall = {
      timeout: 1000 * 25,
      timeoutObj: null,
      serverTimeoutObj: null,
      start: function () {
        // console.log('开始心跳检测');
        var self = this;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function () {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          // console.log('心跳检测...');
          let ping = {
            method: "server.ping",
            params: {},
            id: '1'
          }
          _this.ws.send(JSON.stringify(ping));
        }, this.timeout)
      }
    },
    this.Closes = function () {
      if (_this.ws) {
        _this.ws.close()
        _this.ws = null
      }
    }
}
export default webscokets;

//心跳检测
